import { useMemo } from "react";

import { useEaselSelectedComputeCellNodes } from "./useEaselSelectedNodes";

export const useEaselSelectedComputeCellNodeIds = () => {
	const selectedNodes = useEaselSelectedComputeCellNodes();

	return useMemo(() => {
		return new Set(selectedNodes.map((node) => node.attrs["id"]));
	}, [selectedNodes]);
};
